if (typeof DynaBase_Tabs == 'undefined')
{
    var DynaBase_Tabs =
    {
        /**
         * Zmena miniformulare behem upraveni objektu typu Button
         */
        init: function()
        {
            // Kliknuti na novy  tab
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var id = $(this).parents('.nav-tabs').attr('id');

                var grid;
                if (typeof id != 'undefined') {
                    localStorage.setItem(id, $(e.target).attr('href'));

                    // Nastaveni sirky gridu po prechodu na jiny tab
                    if (grid = $('.ui-jqgrid-btable:visible')) {
                        grid.each(function (index) {
                            gridId = $(this).attr('id');
                            gridParentWidth = $('#gbox_' + gridId).parent().width();
                            $('#' + gridId).setGridWidth(gridParentWidth);
                        });
                    }
                }
            });

            $('.nav-tabs').each(function (idx, elem) {
                var id = $(elem).attr('id');

                if (typeof id != 'undefined') {
                    var lastTabHref = localStorage.getItem(id);

                    if (lastTabHref) {
                        $(elem).find('[href="' + lastTabHref + '"]').tab('show');
                    } else {
                        $(elem).find('a:first').tab('show');
                    }
                } else {
                    $(elem).find('a:first').tab('show');
                }
            });
        }
    }
}
